// extracted by mini-css-extract-plugin
export default {"loaderWrap":"OutreachDetailsModal_loaderWrap__hPPXL"};